import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import getSchoolAction from "./../../actions/SchoolActions/getSchoolAction";
import getSchoolTitleSelector from "../../selectors/SchoolSelectors/getSchoolTitleSelector";
import resetSchoolAction from "../../actions/SchoolActions/resetSchoolAction";
import { useAppTitle } from "../MainHooks/useAppTitle";
import { useParams } from "react-router";

export default function useSchool() {
    const title = useSelector((state: Store) => getSchoolTitleSelector(state));
    const { setAppTitle } = useAppTitle();
    const { id } = useParams<{ id?: string }>();
    const dispatch = useDispatch();
    const getSchool = useCallback((id) => dispatch(getSchoolAction(id)), [dispatch]);
    const resetSchool = useCallback(() => dispatch(resetSchoolAction()), [dispatch]);
    useEffect(() => {
        getSchool(id);
        return () => {
            resetSchool();
        };
    }, [id, getSchool, resetSchool]);
    useEffect(() => {
        setAppTitle(title);
        return () => {
            setAppTitle("");
        };
    }, [title, setAppTitle]);
}
